import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const fetchRecordedContacts = createAsyncThunk(
  "recordedContacts/fetchRecordedContacts",
  async (
    { page = 1, filters = [], sortModel = [] },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().recordedContacts;
      const { pageSize } = state;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.RECORDED_CONTACTS}?${params.toString()}`
      );

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addRecordedContact = createAsyncThunk(
  "recordedContacts/addRecordedContact",
  async (contactData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.post(
        ENDPOINTS.RECORDED_CONTACTS,
        contactData
      );
      dispatch(
        showNotification({
          message: response.data.message,
          type: "success",
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        showNotification({
          message: error.response?.data?.message || error.message,
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateRecordedContact = createAsyncThunk(
  "recordedContacts/updateRecordedContact",
  async ({ id, ...contactData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        `${ENDPOINTS.RECORDED_CONTACTS}/${id}`,
        contactData
      );
      dispatch(
        showNotification({
          message: "Contact updated successfully!",
          type: "success",
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        showNotification({
          message: "Failed to update contact.",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
